import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library, config } from "@fortawesome/fontawesome-svg-core";
import { faCalendarDay, faCalendarXmark, faCalendarCheck, faCalendarCircleUser } from "@fortawesome/pro-regular-svg-icons";

library.add(faCalendarDay, faCalendarXmark, faCalendarCheck, faCalendarCircleUser);
config.familyDefault = "classic";
config.styleDefault = "regular";

export default FontAwesomeIcon;